/* ============================================================
   ELASTIX CUSTOM ELASTIC CONFIGURATOR
   7-step wizard with live canvas preview + conditional rules
   ============================================================ */
(function () {
  'use strict';

  /* ── State ── */
  const state = {
    step: 1,
    product: null,        // waistband | crop-top | boxer | headband
    technique: null,      // jacquard | printed | silicone
    text: '',
    textColour: '#FFFFFF',
    artworkFile: null,
    artworkDataUrl: null,
    bgColour: '#1F5130',
    colours: ['#1F5130'],  // selected palette colours
    widthMm: null,
    widthCustom: '',
    stretch: null,
    elastomer: null,
    packaging: null,
    cutLength: '',
    siliconeGrip: false,
    siliconePattern: 'wavy',
    siliconePlace: 'front',
    doubleSided: false,
    quantity: '',
    unit: 'm',
    contactName: '',
    contactCompany: '',
    contactEmail: '',
    contactPhone: '',
    contactCountry: 'AU',
    sampleRequired: true,
    notes: ''
  };

  const MOQ = { jacquard: 5000, printed: 500, silicone: 5000 };
  const MOQ_YD = { jacquard: 5500, printed: 550, silicone: 5500 };
  const MAX_COLOURS = { jacquard: 7, printed: Infinity, silicone: 4 };

  const DEFAULT_WIDTHS = {
    'waistband':  [20, 25, 30, 38],
    'crop-top':   [40, 50, 60],
    'boxer':      [32, 38, 40],
    'headband':   [20, 25, 30, 40]
  };

  /* ── DOM refs ── */
  let canvas, ctx;

  function $(sel) { return document.querySelector(sel); }
  function $$(sel) { return document.querySelectorAll(sel); }

  /* ── Init ── */
  function init() {
    const wrap = $('.ex-cfg-wrap');
    if (!wrap) return;

    canvas = document.getElementById('ex-cfg-canvas');
    if (canvas) {
      ctx = canvas.getContext('2d');
      canvas.width = 256;
      canvas.height = 80;
    }

    bindStepRail();
    bindStep1();
    bindStep2();
    bindStep3();
    bindStep4();
    bindStep5();
    bindStep6();
    bindStep7();

    showStep(1);
    drawCanvas();
  }

  /* ── Step rail ── */
  function bindStepRail() {
    $$('.ex-cfg-rail__step').forEach(el => {
      el.addEventListener('click', () => {
        const n = parseInt(el.dataset.step);
        if (n < state.step) goToStep(n);
      });
    });
  }

  function updateRail() {
    $$('.ex-cfg-rail__step').forEach(el => {
      const n = parseInt(el.dataset.step);
      el.classList.remove('active', 'done', 'disabled');
      const dot = el.querySelector('.ex-cfg-dot');
      dot.classList.remove('ex-cfg-dot--active', 'ex-cfg-dot--done', 'ex-cfg-dot--future');
      if (n === state.step) {
        el.classList.add('active');
        dot.classList.add('ex-cfg-dot--active');
      } else if (n < state.step) {
        el.classList.add('done');
        dot.classList.add('ex-cfg-dot--done');
      } else {
        el.classList.add('disabled');
        dot.classList.add('ex-cfg-dot--future');
      }
    });
    // progress bar
    const fill = $('.ex-cfg-progress-fill');
    if (fill) fill.style.width = ((state.step - 1) / 6 * 100) + '%';
    // step counter
    const lbl = $('.ex-cfg-step-label');
    if (lbl) lbl.textContent = `Step ${state.step} of 7`;
  }

  /* ── Navigation ── */
  function showStep(n) {
    state.step = n;
    $$('.ex-cfg-step-panel').forEach(p => p.classList.remove('visible'));
    const panel = $(`.ex-cfg-step-panel[data-step="${n}"]`);
    if (panel) panel.classList.add('visible');
    updateRail();
    updateSpecPanel();
    const title = $(`.ex-cfg-step-title`);
    const hint = $(`.ex-cfg-step-hint`);
    const titles = [
      '', // 0 unused
      'Choose your base product',
      'Choose elastic technique',
      'Add your artwork',
      'Colours & width',
      'Production preferences',
      'Your contact details',
      'Review & submit your enquiry'
    ];
    const hints = [
      '',
      'Not sure? Our team will confirm the best product for your use case.',
      'This determines colour limits, MOQ and available options.',
      'Upload a logo or add brand text — or both.',
      'Select background colour, accent colours, and elastic width.',
      'Set stretch, elastomer, packaging and quantity.',
      'We\'ll send your quote to this email address.',
      'Check all details below, then submit. No payment is taken online.'
    ];
    if (title) title.textContent = titles[n];
    if (hint) hint.textContent = hints[n];
    window.scrollTo({ top: wrap().getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
  }

  function wrap() { return $('.ex-cfg-wrap') || document.body; }

  function goToStep(n) { showStep(n); }

  function nextBtn(panelStep, validate) {
    const btn = $(`.ex-cfg-step-panel[data-step="${panelStep}"] .ex-cfg-next`);
    if (!btn) return;
    btn.addEventListener('click', () => {
      if (validate && !validate()) return;
      showStep(panelStep + 1);
    });
    const prevBtn = $(`.ex-cfg-step-panel[data-step="${panelStep}"] .ex-cfg-prev`);
    if (prevBtn && panelStep > 1) {
      prevBtn.addEventListener('click', () => showStep(panelStep - 1));
    }
  }

  /* ── Step 1: Product ── */
  function bindStep1() {
    $$('[data-product]').forEach(el => {
      el.addEventListener('click', () => {
        $$('[data-product]').forEach(o => o.classList.remove('selected'));
        el.classList.add('selected');
        state.product = el.dataset.product;
        // update width defaults
        if (state.technique) applyWidthDefaults();
        updateSpecPanel();
        drawCanvas();
      });
    });
    nextBtn(1, () => {
      if (!state.product) { showInlineError(1, 'Please choose a product to continue.'); return false; }
      return true;
    });
  }

  /* ── Step 2: Technique ── */
  function bindStep2() {
    $$('[data-technique]').forEach(el => {
      el.addEventListener('click', () => {
        $$('[data-technique]').forEach(o => o.classList.remove('selected'));
        el.classList.add('selected');
        state.technique = el.dataset.technique;
        applyTechniqueRules();
        updateSpecPanel();
        drawCanvas();
      });
    });
    nextBtn(2, () => {
      if (!state.technique) { showInlineError(2, 'Please choose an elastic technique.'); return false; }
      return true;
    });
  }

  function applyTechniqueRules() {
    const t = state.technique;
    // Rule 13: Printed locks stretch + elastomer
    if (t === 'printed') {
      state.stretch = 'average';
      state.elastomer = 'spandex';
    }
    // Rule 6: Silicone locks construction
    if (t === 'silicone') {
      // nothing to reset yet, just note it
    }
    // Colour limits
    if (t === 'jacquard' && state.colours.length > 7) {
      state.colours = state.colours.slice(0, 7);
    }
    if (t === 'silicone' && state.colours.length > 4) {
      state.colours = state.colours.slice(0, 4);
    }
    // Artwork warning
    checkArtworkWarnings();
    applyWidthDefaults();
  }

  /* ── Step 3: Artwork ── */
  function bindStep3() {
    const fileInput = document.getElementById('ex-cfg-file');
    const uploadArea = $('.ex-cfg-upload');
    const preview = $('.ex-cfg-upload-preview');
    const removeBtn = $('.ex-cfg-upload-preview__remove');
    const textInput = document.getElementById('ex-cfg-text');
    const warnRaster = document.getElementById('ex-cfg-warn-raster');

    if (uploadArea) {
      uploadArea.addEventListener('dragover', e => { e.preventDefault(); uploadArea.classList.add('dragover'); });
      uploadArea.addEventListener('dragleave', () => uploadArea.classList.remove('dragover'));
      uploadArea.addEventListener('drop', e => {
        e.preventDefault();
        uploadArea.classList.remove('dragover');
        const f = e.dataTransfer.files[0];
        if (f) handleFile(f);
      });
    }
    if (fileInput) {
      fileInput.addEventListener('change', () => {
        if (fileInput.files[0]) handleFile(fileInput.files[0]);
      });
    }
    if (removeBtn) {
      removeBtn.addEventListener('click', e => {
        e.stopPropagation();
        state.artworkFile = null;
        state.artworkDataUrl = null;
        preview && preview.classList.remove('visible');
        if (fileInput) fileInput.value = '';
        drawCanvas();
        checkArtworkWarnings();
      });
    }
    if (textInput) {
      textInput.addEventListener('input', () => {
        state.text = textInput.value;
        drawCanvas();
      });
    }
    nextBtn(3, () => {
      if (!state.artworkFile && !state.text.trim()) {
        showInlineError(3, 'Add a logo file or brand text to continue.');
        return false;
      }
      return true;
    });

    function handleFile(f) {
      const isRaster = /\.(png|jpg|jpeg|gif|bmp|webp)$/i.test(f.name);
      state.artworkFile = f;
      if (warnRaster) {
        warnRaster.style.display = (isRaster && state.technique !== 'printed') ? 'block' : 'none';
      }
      const reader = new FileReader();
      reader.onload = e => {
        state.artworkDataUrl = e.target.result;
        if (preview) {
          preview.classList.add('visible');
          const img = preview.querySelector('img');
          const name = preview.querySelector('.ex-cfg-upload-preview__name');
          if (img && isRaster) img.src = state.artworkDataUrl;
          else if (img) img.src = ''; // no thumbnail for SVG in this context
          if (name) name.textContent = f.name;
        }
        drawCanvas();
        checkArtworkWarnings();
      };
      reader.readAsDataURL(f);
    }
  }

  function checkArtworkWarnings() {
    const warnRaster = document.getElementById('ex-cfg-warn-raster');
    if (warnRaster && state.artworkFile) {
      const isRaster = /\.(png|jpg|jpeg)$/i.test(state.artworkFile.name);
      warnRaster.style.display = (isRaster && state.technique !== 'printed') ? 'block' : 'none';
    }
  }

  /* ── Step 4: Colours & Width ── */
  function bindStep4() {
    // bg colour input
    const bgInput = document.getElementById('ex-cfg-bg-colour');
    const bgHex = document.getElementById('ex-cfg-bg-hex');
    if (bgInput) {
      bgInput.value = state.bgColour;
      bgInput.addEventListener('input', () => {
        state.bgColour = bgInput.value;
        if (bgHex) bgHex.value = bgInput.value;
        drawCanvas();
        updateSpecPanel();
      });
    }
    if (bgHex) {
      bgHex.addEventListener('input', () => {
        if (/^#[0-9A-Fa-f]{6}$/.test(bgHex.value)) {
          state.bgColour = bgHex.value;
          if (bgInput) bgInput.value = bgHex.value;
          drawCanvas();
        }
      });
    }
    // width pills
    $$('[data-width]').forEach(pill => {
      pill.addEventListener('click', () => {
        $$('[data-width]').forEach(p => p.classList.remove('active'));
        pill.classList.add('active');
        state.widthMm = parseInt(pill.dataset.width);
        state.widthCustom = '';
        const customInput = document.getElementById('ex-cfg-width-custom');
        if (customInput) customInput.value = '';
        applyWidthRules();
        updateSpecPanel();
        drawCanvas();
      });
    });
    const customInput = document.getElementById('ex-cfg-width-custom');
    if (customInput) {
      customInput.addEventListener('input', () => {
        state.widthCustom = customInput.value;
        state.widthMm = parseInt(customInput.value) || null;
        $$('[data-width]').forEach(p => p.classList.remove('active'));
        applyWidthRules();
        updateSpecPanel();
        drawCanvas();
      });
    }
    // Pantone field
    const pantoneInput = document.getElementById('ex-cfg-pantone');
    if (pantoneInput) {
      pantoneInput.addEventListener('input', () => { /* store if needed */ });
    }
    nextBtn(4, () => {
      if (!state.widthMm) { showInlineError(4, 'Please select or enter an elastic width.'); return false; }
      return true;
    });
  }

  function applyWidthRules() {
    // Rule 22–23: packaging gating by width
    const packSpoolRadio = document.getElementById('ex-cfg-pack-spool');
    const packRollRadio = document.getElementById('ex-cfg-pack-roll');
    if (!state.widthMm) return;
    if (packSpoolRadio) packSpoolRadio.disabled = state.widthMm >= 20;
    if (packRollRadio) packRollRadio.disabled = state.widthMm < 20;
    if (state.widthMm < 20 && state.packaging === 'roll') state.packaging = null;
    if (state.widthMm >= 20 && state.packaging === 'spool') state.packaging = null;
  }

  function applyWidthDefaults() {
    const defaults = (state.product && DEFAULT_WIDTHS[state.product]) || [];
    const container = document.getElementById('ex-cfg-width-pills');
    if (!container) return;
    // Re-render pills
    const pills = container.querySelectorAll('[data-width]');
    pills.forEach(p => { container.removeChild(p); });
    defaults.forEach(w => {
      const pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'ex-cfg-width-pill';
      pill.dataset.width = w;
      pill.textContent = w + ' mm';
      if (state.widthMm === w) pill.classList.add('active');
      container.insertBefore(pill, container.querySelector('#ex-cfg-width-custom'));
      pill.addEventListener('click', () => {
        container.querySelectorAll('[data-width]').forEach(p => p.classList.remove('active'));
        pill.classList.add('active');
        state.widthMm = w;
        state.widthCustom = '';
        const ci = document.getElementById('ex-cfg-width-custom');
        if (ci) ci.value = '';
        applyWidthRules();
        updateSpecPanel();
        drawCanvas();
      });
    });
  }

  /* ── Step 5: Production prefs ── */
  function bindStep5() {
    $$('[data-stretch]').forEach(el => {
      el.addEventListener('click', () => {
        if (state.technique === 'printed') return;
        $$('[data-stretch]').forEach(o => o.classList.remove('active'));
        el.classList.add('active');
        state.stretch = el.dataset.stretch;
        updateSpecPanel();
      });
    });
    $$('[data-elastomer]').forEach(el => {
      el.addEventListener('click', () => {
        if (state.technique === 'printed') return;
        $$('[data-elastomer]').forEach(o => o.classList.remove('active'));
        el.classList.add('active');
        state.elastomer = el.dataset.elastomer;
        checkElastomerWarning();
        updateSpecPanel();
      });
    });
    $$('[name="ex-cfg-packaging"]').forEach(el => {
      el.addEventListener('change', () => {
        state.packaging = el.value;
        const cutSection = document.getElementById('ex-cfg-cut-section');
        if (cutSection) cutSection.style.display = (el.value === 'cut' || el.value === 'loop') ? 'block' : 'none';
        updateSpecPanel();
      });
    });
    const qtyInput = document.getElementById('ex-cfg-qty');
    const unitSelect = document.getElementById('ex-cfg-unit');
    if (qtyInput) {
      qtyInput.addEventListener('input', () => {
        state.quantity = qtyInput.value;
        checkMOQ();
        updateSpecPanel();
      });
    }
    if (unitSelect) {
      unitSelect.addEventListener('change', () => {
        state.unit = unitSelect.value;
        checkMOQ();
        updateSpecPanel();
      });
    }
    const gripToggle = document.getElementById('ex-cfg-grip');
    if (gripToggle) {
      gripToggle.addEventListener('change', () => {
        state.siliconeGrip = gripToggle.checked;
        const gripOpts = document.getElementById('ex-cfg-grip-opts');
        if (gripOpts) gripOpts.style.display = state.siliconeGrip ? 'grid' : 'none';
        updateSpecPanel();
      });
    }
    // Lock printed options
    if (state.technique === 'printed') {
      $$('[data-stretch]').forEach(el => {
        el.classList.toggle('active', el.dataset.stretch === 'average');
        el.classList.add('disabled');
      });
      $$('[data-elastomer]').forEach(el => {
        el.classList.toggle('active', el.dataset.elastomer === 'spandex');
        el.classList.add('disabled');
      });
    }
    nextBtn(5, () => {
      const qty = parseFloat(state.quantity);
      if (!qty || qty <= 0) { showInlineError(5, 'Please enter a quantity.'); return false; }
      return true;
    });
  }

  function checkMOQ() {
    const moqWarn = document.getElementById('ex-cfg-moq-warn');
    if (!moqWarn || !state.technique) return;
    const qty = parseFloat(state.quantity);
    const moq = state.unit === 'm' ? MOQ[state.technique] : MOQ_YD[state.technique];
    const altLabel = state.technique !== 'printed' ? ` Consider printed elastic (MOQ ${MOQ.printed} m).` : '';
    if (qty && qty < moq) {
      moqWarn.style.display = 'block';
      moqWarn.textContent = `Minimum order is ${moq.toLocaleString()} ${state.unit} for ${state.technique} elastic.${altLabel}`;
      if (qty >= moq * 0.9) {
        moqWarn.style.borderColor = '#E8C96B';
        moqWarn.style.background = '#FEF6E4';
        moqWarn.textContent += ' — slightly under minimum? Contact us, a small tolerance may be possible.';
      }
    } else {
      moqWarn.style.display = 'none';
    }
  }

  function checkElastomerWarning() {
    const warn = document.getElementById('ex-cfg-elastomer-warn');
    if (!warn) return;
    warn.style.display = (state.elastomer === 'latex') ? 'block' : 'none';
  }

  /* ── Step 6: Contact ── */
  function bindStep6() {
    const fields = {
      'ex-cfg-name': 'contactName',
      'ex-cfg-company': 'contactCompany',
      'ex-cfg-email': 'contactEmail',
      'ex-cfg-phone': 'contactPhone',
      'ex-cfg-country': 'contactCountry',
      'ex-cfg-notes': 'notes'
    };
    Object.entries(fields).forEach(([id, key]) => {
      const el = document.getElementById(id);
      if (el) el.addEventListener('input', () => { state[key] = el.value; });
    });
    const sampleRadios = $$('[name="ex-cfg-sample"]');
    sampleRadios.forEach(r => {
      r.addEventListener('change', () => { state.sampleRequired = r.value === 'yes'; });
    });
    nextBtn(6, () => {
      const missing = [];
      if (!state.contactName) missing.push('name');
      if (!state.contactCompany) missing.push('company');
      if (!state.contactEmail || !/^[^@]+@[^@]+\.[^@]+$/.test(state.contactEmail)) missing.push('valid email');
      if (!state.contactPhone || state.contactPhone.replace(/\D/g,'').length < 8) missing.push('phone');
      if (missing.length) { showInlineError(6, 'Please complete: ' + missing.join(', ') + '.'); return false; }
      buildReview();
      return true;
    });
  }

  /* ── Step 7: Review & Submit ── */
  function bindStep7() {
    const form = document.getElementById('ex-cfg-form');
    if (form) {
      form.addEventListener('submit', e => {
        e.preventDefault();
        submitEnquiry();
      });
    }
  }

  function buildReview() {
    const tbody = document.getElementById('ex-cfg-review-body');
    if (!tbody) return;
    const rows = [
      ['Product', labelProduct(state.product)],
      ['Technique', labelTechnique(state.technique)],
      ['Width', state.widthMm ? state.widthMm + ' mm' : state.widthCustom + ' mm (custom)'],
      ['Quantity', state.quantity ? state.quantity + ' ' + state.unit : '—'],
      ['Background colour', state.bgColour],
      ['Colour count', state.colours.length],
      ['Brand text', state.text || '—'],
      ['Artwork file', state.artworkFile ? state.artworkFile.name : '—'],
      ['Stretch', state.stretch ? capitalise(state.stretch) : '—'],
      ['Elastomer', state.elastomer ? capitalise(state.elastomer) : '—'],
      ['Packaging', state.packaging ? labelPackaging(state.packaging) : '—'],
      ['Silicone grip', state.siliconeGrip ? capitalise(state.siliconePattern) + ', ' + capitalise(state.siliconePlace) : 'No'],
      ['Sample required', state.sampleRequired ? 'Yes' : 'No'],
      ['Name', state.contactName],
      ['Company', state.contactCompany],
      ['Email', state.contactEmail],
      ['Phone', state.contactPhone],
      ['Country', state.contactCountry],
      ['Notes', state.notes || '—']
    ];
    tbody.innerHTML = rows.map(([k, v]) =>
      `<tr><td>${k}</td><td>${v}</td></tr>`
    ).join('');
    // canvas final
    drawCanvas();
  }

  function submitEnquiry() {
    const submitBtn = document.getElementById('ex-cfg-submit');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Submitting…'; }
    const body = buildSubmissionBody();
    const params = new URLSearchParams({
      'contact[name]':    state.contactName,
      'contact[email]':   state.contactEmail,
      'contact[phone]':   state.contactPhone,
      'contact[body]':    body
    });
    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
      body: params.toString()
    })
    .then(r => r.ok ? r.json() : Promise.reject(r))
    .then(() => {
      showSuccess();
    })
    .catch(() => {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Submit Enquiry'; }
      showInlineError(7, 'Submission failed. Please try again or email us directly.');
    });
  }

  function buildSubmissionBody() {
    const lines = [
      'ELASTIX CUSTOM ELASTIC ENQUIRY',
      '================================',
      '',
      `Product:         ${labelProduct(state.product)}`,
      `Technique:       ${labelTechnique(state.technique)}`,
      `Width:           ${state.widthMm ? state.widthMm + ' mm' : state.widthCustom + ' mm (custom)'}`,
      `Quantity:        ${state.quantity} ${state.unit}`,
      `Background:      ${state.bgColour}`,
      `Colour count:    ${state.colours.length} (${state.colours.join(', ')})`,
      `Brand text:      ${state.text || '(none)'}`,
      `Artwork file:    ${state.artworkFile ? state.artworkFile.name : '(none — will email separately)'}`,
      `Stretch:         ${state.stretch ? capitalise(state.stretch) : 'Not specified'}`,
      `Elastomer:       ${state.elastomer ? capitalise(state.elastomer) : 'Not specified'}`,
      `Packaging:       ${state.packaging ? labelPackaging(state.packaging) : 'Not specified'}`,
      `Silicone grip:   ${state.siliconeGrip ? capitalise(state.siliconePattern) + ', ' + capitalise(state.siliconePlace) : 'No'}`,
      `Sample required: ${state.sampleRequired ? 'Yes' : 'No'}`,
      '',
      'CONTACT',
      `Name:    ${state.contactName}`,
      `Company: ${state.contactCompany}`,
      `Email:   ${state.contactEmail}`,
      `Phone:   ${state.contactPhone}`,
      `Country: ${state.contactCountry}`,
      '',
      state.notes ? 'Notes:\n' + state.notes : '',
      '',
      '--- Submitted via Elastix online configurator ---'
    ];
    return lines.filter(l => l !== undefined).join('\n');
  }

  function showSuccess() {
    const wrap = $('.ex-cfg-wrap');
    if (!wrap) return;
    wrap.innerHTML = `
      <div style="padding:60px 40px; text-align:center; background:var(--ex-warm-white);">
        <div style="width:60px;height:60px;border-radius:50%;background:var(--ex-signal);display:flex;align-items:center;justify-content:center;margin:0 auto 20px;font-size:28px;color:#fff;">✓</div>
        <h2 class="ex-h2" style="margin:0 0 14px;">Enquiry received!</h2>
        <p class="ex-body" style="max-width:46ch;margin:0 auto 28px;color:var(--ex-muted);">We've received your design enquiry and will reply with a quote within two business days. Check your inbox at <strong>${state.contactEmail}</strong>.</p>
        <p class="ex-body" style="max-width:46ch;margin:0 auto 24px;font-size:13.5px;color:var(--ex-muted);">If you uploaded artwork, please also email your files to <strong>info@elastix.com.au</strong> referencing your name and company.</p>
        <a href="/" class="ex-btn ex-btn-primary">Back to home</a>
      </div>`;
  }

  /* ── Canvas preview ── */
  function drawCanvas() {
    if (!canvas || !ctx) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // 1. Background
    ctx.fillStyle = state.bgColour || '#1F5130';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // 2. Woven texture overlay (subtle horizontal lines)
    ctx.strokeStyle = 'rgba(255,255,255,0.06)';
    ctx.lineWidth = 1;
    for (let y = 4; y < canvas.height; y += 6) {
      ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(canvas.width, y); ctx.stroke();
    }

    // 3. Artwork image
    if (state.artworkDataUrl) {
      const img = new Image();
      img.onload = () => {
        const ar = img.width / img.height;
        const h = Math.min(50, canvas.height - 20);
        const w = h * ar;
        const x = (canvas.width - w) / 2;
        const y = (canvas.height - h) / 2;
        ctx.drawImage(img, x, y, w, h);
        drawText();
        drawEdgelines();
      };
      img.src = state.artworkDataUrl;
    } else {
      drawText();
      drawEdgelines();
    }
  }

  function drawText() {
    if (!state.text) return;
    const widthFraction = Math.min((state.widthMm || 30) / 80, 0.9);
    const fontSize = Math.max(10, Math.floor(canvas.height * widthFraction * 0.45));
    ctx.font = `700 ${fontSize}px 'Archivo', Arial, sans-serif`;
    ctx.fillStyle = state.textColour || '#FFFFFF';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    // tiled repeat
    const textW = ctx.measureText(state.text).width;
    const gap = textW + 16;
    for (let x = gap / 2; x < canvas.width + gap; x += gap) {
      ctx.fillText(state.text, x, canvas.height / 2);
    }
  }

  function drawEdgelines() {
    // Top and bottom brand edge lines
    ctx.fillStyle = state.colours[1] || state.colours[0] || '#FFFFFF';
    ctx.fillRect(0, 0, canvas.width, 3);
    ctx.fillRect(0, canvas.height - 3, canvas.width, 3);
  }

  /* ── Spec panel ── */
  function updateSpecPanel() {
    const rows = {
      'ex-spec-type':    labelTechnique(state.technique),
      'ex-spec-width':   state.widthMm ? state.widthMm + ' mm' : '—',
      'ex-spec-colours': state.colours.length > 0 ? state.colours.length.toString() : '—',
      'ex-spec-moq':     state.technique ? MOQ[state.technique].toLocaleString() + ' m' : '—',
    };
    Object.entries(rows).forEach(([id, val]) => {
      const el = document.getElementById(id);
      if (!el) return;
      el.textContent = val;
      el.classList.toggle('empty', val === '—');
    });
    drawCanvas();
  }

  /* ── Error display ── */
  function showInlineError(step, msg) {
    const panel = $(`.ex-cfg-step-panel[data-step="${step}"]`);
    if (!panel) return;
    let err = panel.querySelector('.ex-cfg-error');
    if (!err) {
      err = document.createElement('p');
      err.className = 'ex-warning ex-cfg-error';
      panel.querySelector('.ex-cfg-nav')?.before(err);
    }
    err.textContent = msg;
    err.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    setTimeout(() => { if (err) err.remove(); }, 4000);
  }

  /* ── Helpers ── */
  function capitalise(s) { return s ? s[0].toUpperCase() + s.slice(1) : ''; }
  function labelProduct(p) {
    return { 'waistband': 'Custom Waistband Elastic', 'crop-top': 'Crop Top Band', 'boxer': 'Boxer Short Waistband', 'headband': 'Custom Headband' }[p] || '—';
  }
  function labelTechnique(t) {
    return { 'jacquard': 'Woven Jacquard', 'printed': 'Dye-Sublimated Printed', 'silicone': 'Silicone Logo' }[t] || '—';
  }
  function labelPackaging(p) {
    return { 'roll': '50 m rolls', 'spool': 'Spool', 'layered': 'Layered in bag/carton', 'cut': 'Cut to length', 'loop': 'Cut & sewn loop' }[p] || p;
  }

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
